import { render } from "./Registering.vue?vue&type=template&id=4569867b&scoped=true&ts=true"
import script from "./Registering.vue?vue&type=script&lang=ts"
export * from "./Registering.vue?vue&type=script&lang=ts"

import "./Registering.vue?vue&type=style&index=0&id=4569867b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4569867b"]])

export default __exports__